import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const ChartDemoBanner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.chartDemoBanner} aria-hidden="true">
      <span>{t('demoMode.chartBanner')}</span>
    </div>
  );
};

export default ChartDemoBanner;
